<template>
  <!-- 开评标项目起始列表页 -->
  <div class="main_center">
    <div class="content">

      <el-form ref="form" :model="search" label-width="110px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="年份：" label-width="75px">
              <el-select v-model="search.year" value-key="value" style="width:100%;" @change="yearsChange">
                <el-option v-for="(item, index) in yearsList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item label="招标人：" props="tendererName">
              <el-input v-model="search.tendererName" clearable placeholder="请输入内容搜索"
                @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="项目名称：">
              <el-input v-model="search.bidName" clearable placeholder="请输入内容搜索"
                @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="交易中心：">
              <el-select v-model="search.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item, index) in transactionCenterList" :key="index" :label="item.orgName"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <div style="float:right;margin-right: 10px;margin-bottom: 10px">
            <el-button size="small" type="primary" style="margin-left:30px;" @click="seachBtn">搜索</el-button>
            <el-button plain size="small" type="primary" style="margin-left:10px;" @click="reflash">重置</el-button>
          </div>
        </el-row>
      </el-form>

      <space :left="-16" :right="-16" :bottom="16" />
      <el-row :gutter="15" :style="{ 'min-height': tableMaxHeight }" v-loading="dataListLoading">
        <el-col :span="6" v-for="(item, index) in tableData" style="min-width: 180px" :key="item.id">

          <el-card class="projectCard">
            <div slot="header" class="clearfix">
              <span class="title" :title="item.bidName">{{ item.bidName }}</span>
              <div class="item-tag">
                <span class="defult-status" :class="getItemObj(item, ['bid','tagClass'])">
                  <span class="ing-icon" v-if="item.openStatus == 2"></span>{{ getItemObj(item, ['bid', 'text']) }}</span>
                <span class="defult-status" :class="getItemObj(item, ['eval','tagClass'])">
                  <span class="ing-icon" v-if="item.evalStatus == 3"></span>{{ getItemObj(item, ['eval', 'text']) }}</span>
              </div>
            </div>
            <!-- <div class="processStatus">
              <img :src="status1" v-if="item.status == 1">
              <img :src="status2" v-if="item.status == 2">
              <img :src="status3" v-if="item.status == 3">
              <img :src="status4" v-if="item.status == 4">
            </div> -->
            <!--            <h3 style="text-align: center;margin: 10px auto" class="activeColor">{{ formatterBidStatus(item.status) }}</h3>-->
            <p class="info"><span>编号：</span><span :title="item.tradePlatfBidSectionCode">{{ item.tradePlatfBidSectionCode }}</span></p>
            <p class="info"><span>开标时间：</span><span :title="item.tendererName">{{ formatDate(item.bidopenTime, 'yyyy-MM-dd HH:mm') }}</span></p>
            <p class="info" v-if="item.bidopenRooms && item.bidopenRooms.length > 0">
              <span>开标室：</span>
              <span class="link" v-for="room in item.bidopenRooms" :key="room.id"
                @click="routerGO(item.bidCode, 2, room.code, item.status, item.bidopenHistoryid, item.dataSource, item.tradePlatfBidSectionId)">
                {{ room.name }}
              </span>
            </p>
            <p class="info" v-else>
              <span>开标室：</span><span style="color: red">未预约</span>
            </p>
            <p class="info" v-if="item.estimateRooms && item.estimateRooms.length > 0">
              <span>评标室：</span>
              <span class="link" v-for="room in item.estimateRooms" :key="room.id"
                @click="routerGO(item.bidCode, 3, room.code, item.status, item.estimateHistoryid, item.dataSource, item.tradePlatfBidSectionId)">
                {{ room.name }}
              </span>
            </p>
            <p class="info" v-else>
              <span>评标室：</span><span style="color: red">未预约</span>
            </p>
            <p class="info"><span>招标人：</span><span :title="item.createTime">{{ item.tendererName }}</span></p>
          </el-card>

        </el-col>
        <emptyInfo v-if="tableData.length == 0" :emptyMsg="'暂无记录'"></emptyInfo>
      </el-row>


      <!--
      <el-pagination background
                     layout="sizes, prev, pager, next"
                     :page-sizes="[pageSize, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
      <pagination class="limit" :page-sizes="[10, 20, 50, 100]" :total="total" :page.sync="pageIndex"
        :limit.sync="pageSize" @pagination="paginationChange">
      </pagination>

    </div>
  </div>
</template>

<script>

import emptyInfo from '@/components/empty-info';
import { nearSixYearsList } from '@/utils/index';
import space from '../../../common/components/space.vue';
import Pagination from '@/components/Pagination.vue';

// const evalStatusEnum = [ //评标
//   { text: '等待评标', value: '1', tagClass: null, btnText: '评标视频见证', },
//   { text: '评标准备中', value: '2', tagClass: null, btnText: '评标视频见证', },
//   { text: '评标中', value: '3', tagClass: 'ing-status', btnText: '评标视频见证', },
//   { text: '已流标', value: '4', tagClass: null, btnText: '评标见证记录', },
//   { text: '评标结束', value: '5', tagClass: 'end-status', btnText: '评标见证记录',}
// ];
const evalStatusEnuMap = { //评标
  '1': { text: '等待评标', tagClass: null, btnText: '评标视频见证', },
  '2': { text: '评标准备中', tagClass: null, btnText: '评标视频见证', },
  '3': { text: '评标中', tagClass: 'ing-status', btnText: '评标视频见证', },
  '4': { text: '已流标', tagClass: null, btnText: '评标见证记录', },
  '5': { text: '评标结束', tagClass: 'end-status', btnText: '评标见证记录', }
};
// const openStatusEnum = [ //不见面
//   { text: '待开标', value: 0, tagClass: null, btnText: '开标视频见证', },
//   { text: '待开标', value: 1, tagClass: null, btnText: '开标视频见证', },
//   { text: '开标中', value: 2, tagClass: 'ing-status', btnText: '开标视频见证', },
//   { text: '取消开标', value: 3, tagClass: null, btnText: '开标视频见证', },
//   { text: '开标流标', value: 4, tagClass: null, btnText: '开标视频见证', },
//   { text: '开标结束', value: 5, tagClass: 'end-status', btnText: '开标见证记录', },
// ]
const openStatusEnuMap = { //不见面
  '0': { text: '待开标', tagClass: null, btnText: '开标视频见证', },
  '1': { text: '待开标', tagClass: null, btnText: '开标视频见证', },
  '2': { text: '开标中', tagClass: 'ing-status', btnText: '开标视频见证', },
  '3': { text: '取消开标', tagClass: null, btnText: '开标视频见证', },
  '4': { text: '开标流标', tagClass: null, btnText: '开标视频见证', },
  '5': { text: '开标结束', tagClass: 'end-status', btnText: '开标见证记录', },
}

export default {
  components: {
    emptyInfo,
    space,
    Pagination
  },
  data() {
    return {
      tableMaxHeight: (document.documentElement.clientHeight - 260) + 'px',
      dataListLoading: false,
      yearsList: [],
      search: {
        year: new Date().getFullYear(),
        bidName: "",//项目名称
        tendererName: "", //所属机构
        tradeId: '', // 交易中心ID
      },
      status1: require('@/assets/images/bid_status1.png'),
      status2: require('@/assets/images/bid_status2.png'),
      status3: require('@/assets/images/bid_status3.png'),
      status4: require('@/assets/images/bid_status4.png'),
      form: {    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataGroup: "",   //是否关联项目  1:关联项目  2:关联标段
        dataType: "",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标开始时间
        evalStime: "",  //评标结束时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        witnessContent: "",
        witnessUserId: "",
        project: {  //项目数据
          id: "",
          projectCode: "",   //项目编号
          projectName: "",   //项目名称
          tenderAgencyName: "", //招标代理机构名称
          tendererName: ""   //招标人名称
        },
        bid: { //标段数据
          tendererName: ''//招标人名称
        },
      },
      pageSize: 12,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      transactionCenterList: [],
      user: '', //角色类型
      formData: {}
    }
  },
  created() {
    this.yearsList = nearSixYearsList(this.search.year)
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
  },
  activated() {

    this.getDataList()
  },
  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    // 获取status 状态
    getItemObj(_item, keys) {
      let obj = {
        bid: {},
        eval: {}
      };
      // for (const item of evalStatusEnum) {
      //   if (item.value == _item.evalStatus) {
      //     obj.eval = {
      //       text: item.text,
      //       tagClass: item.tagClass,
      //       btnText: item.btnText,
      //     }
      //   }
      // }
      obj.eval = evalStatusEnuMap[_item.evalStatus] || {};
      // for (const item of openStatusEnum) {
      //   if (item.value == _item.openStatus) {
      //     obj.bid = {
      //       text: item.text,
      //       tagClass: item.tagClass,
      //       btnText: item.btnText,
      //     }
      //   }
      // }
      obj.bid = openStatusEnuMap[_item.openStatus] || {};
      return obj[keys[0]][keys[1]];
    },

    ifmove() {


      let tableMaxHeight = (document.documentElement.clientHeight - 260) + 'px';
      this.pageIndex = 1;
      if (document.documentElement.clientHeight > 900) {
        this.pageSize = 12
      } else if (document.documentElement.clientHeight < 770) {
        this.pageSize = 8
      } else {
        this.pageSize = 8
      }
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      this.getDataList()

    },
    yearsChange(val) {
      this.yearsList = nearSixYearsList(val)
      this.getDataList()
    },


    reflash() {
      this.pageIndex = 1;
      this.$refs['form'].resetFields();
      this.search = {
        year: new Date().getFullYear(),
        bidName: "",//项目名称
        tendererName: "", //所属机构
      };
      this.yearsList = nearSixYearsList(this.search.year);
      this.getDataList()
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj) {
      this.pageIndex = obj.page || 1
      this.pageSize = obj.limit || 10
      this.getDataList();
    },
    routerGO(code, dataType, roomCode, status, historyId, dataSource, tradePlatfBidSectionId) {
      let route_name = "";
      if (dataType == 2) {
        route_name = "openBidWitness" + "_detail"  //编辑页面
      } else {
        route_name = "estimateBidWitness" + "_detail" //编辑页面
      }
      // 1 等待开标 2 开标中，3评标中 4评标结束
      if (status == 1) {
        this.$message.error("暂未开标，请稍候。")
        return
      }

      if (status == 4 && (historyId == 100 || historyId == 0)) { // 100 指没有保存实时见证数据，0 指见证数据已提交
        this.$message.error("评标已结束")
        return
      }

      this.$router.push({
        name: route_name,
        query: {
          id: code,
          roomCode: roomCode,
          dataSource: dataSource,
          tradePlatfBidSectionId
        }
      });

      // this.$http.get('/tradding/traddingwitness/getOpenEstimateWitness?id=' + id + '&dataType=' + dataType).then(res => {
      //   if (res.data.code == '1') {
      //     if (res.data.data == null) { //如果没有数据
      //         if (status == 2) {//开标中
      //           route_name=pagePrefix+"_detail"  //编辑页面
      //         }
      //         if (status == 3) {//评标中
      //           route_name=pagePrefix+"_detail" //编辑页面
      //         }
      //     } else { //如果有数据
      //         console.log(res.data.data.historyid)
      //         if (res.data.data.historyid == -1) {
      //             route_name=pagePrefix+"_detail";  //编辑页面
      //         }else {
      //             route_name=pagePrefix+"_view";  //查看页面
      //         }
      //     }
      //   }
      //
      //   if (route_name != "") {
      //     this.$router.push({
      //       name: route_name,
      //       params: {
      //         id: id,
      //         roomCode: roomCode
      //       }
      //     });
      //   }else {
      //     this.$message.error("没有数据记录!")
      //   }
      //
      //
      // })


    },


    getDataList() { // 获取列表数据
      this.dataListLoading = true;
      this.$http.post('/tradding/traddingwitness/getBidVoList', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': '',
        'filter': {
          "bidName": this.search.bidName, //项目名称
          "tendererName": this.search.tendererName,//所属机构
          "year": this.search.year,
          "tradeId": this.search.tradeId
        }
      }).then(res => {
        this.dataListLoading = false;
        this.tableData = res.data.rows;
        this.total = res.data.total;
      })

    },

    seachBtn() { //搜索按钮
      this.getDataList()
    },




    formatterBidStatus(status) {
      switch (status) {
        case 1:
          return '等待开标';
          break;
        case 2:
          return '开标中';
          break;
        case 3:
          return '评标中';
          break;
        case 4:
          return '评标结束';
          break;
      }
    },
    //跳转到开标见证详页
    router_toOpen(item) {
      let route_name = "";
      this.$http.get('/tradding/traddingwitness/getOpenEstimateWitness?id=' + item.businessexId + '&dataType=2').then(res => {
        if (res.data.code == '1') {
          if (res.data.data.historyid == 0) {
            route_name = "openBidWitness_view";
          } else {
            route_name = "openBidWitness_detail";
          }
        }

        this.$router.push({
          name: route_name,
          params: {
            id: item.id
          }
        })

      })


    },
    //跳转到评标记录详页
    router_toEstimate(item) {
      console.log(item)
      let route_name = "";
      this.$http.get('/tradding/traddingwitness/getOpenEstimateWitness?id=' + item.businessexId + '&dataType=3').then(res => {
        if (res.data.code == '1') {
          if (res.data.data.historyid == 0) {
            route_name = "estimateBidWitness_view";
          } else {
            route_name = "estimateBidWitness_detail";
          }
        }

        this.$router.push({
          name: route_name,
          params: {
            id: item.id
          }
        })

      })
    }



  }
}
</script>


<style lang="less" scoped>
.main_center {

  .projectCard {
    border: 1px solid rgba(37, 104, 236, 0.2);

    /deep/ .el-card__body {
      padding: 0;
    }

    /deep/ .el-card__header {
      text-align: center;
      padding: 16px 16px 0px 16px;
      background-color: #E3ECFB;
    }

    /deep/ .el-card__body {
      background-color: rgba(175, 210, 240, 0.1);
      padding-bottom: 10px;
    }

    .processStatus {
      top: 10px;
    }

    .title {
      text-align: left;
      margin-bottom: 10px;
      padding-right: 70px;
    }
    .item-tag {
      margin-left: 14px;
      text-align: right;
      max-width: 80px;

      width: 80px;
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 0px;
      top: 0px;
      .defult-status {
        &::before {
          border-color: transparent transparent transparent #E3ECFB;
        }
      }
    }
  }



}
</style>
